import { ModalTypes } from "@lib/enums/ModalTypes";

export const RUM_ACTION_NAME = {
    LOG_IN: "Log in",
    LOG_OUT: "Log out",
    CREATE_ACCOUNT: "Create account",
    FORGOT_PASSWORD: "Forgot password",
    UPGRADE_ACCOUNT: "Upgrade account",
    SELECT_SIZE: "Select size",
    ADD_TO_CART: "Add to cart",
    NOTIFY_ME: "Notify me",
    NOTIFY_ME_SUBMIT: "Notify me submit",
    ADD_TO_WISHLIST: "Add to wishlist",
    OPEN_CART: "Open cart",
    GO_TO_CHECKOUT: "Go to checkout",
    APPLY_PROMO_CODE: "Apply promo code",
    REMOVE_FROM_CART: "Remove from cart",
    CHECKOUT_CONTACT_SUBMIT: "Checkout contact submit",
    CHECKOUT_DELIVERY_SUBMIT: "Checkout delivery submit",
    PLACE_ORDER_ZERO_TOTAL: "Place order (zero total)",
} as const;

export type RumActionName = (typeof RUM_ACTION_NAME)[keyof typeof RUM_ACTION_NAME];

const MODAL_ACTION_NAMES: Partial<Record<string, RumActionName>> = {
    [ModalTypes.login]: RUM_ACTION_NAME.LOG_IN,
    [ModalTypes.createAccount]: RUM_ACTION_NAME.CREATE_ACCOUNT,
    [ModalTypes.forgotPassword]: RUM_ACTION_NAME.FORGOT_PASSWORD,
};

/**
 * Modal triggers render CMS-driven labels, so the modal they open is the only
 * non-localized identity available for the click.
 */
export const getModalRumActionName = (modal?: string): RumActionName | undefined =>
    modal ? MODAL_ACTION_NAMES[modal] : undefined;
